export default __webpack_public_path__ + "static/media/ImportUser.444ca4d2.xlsx";